import React, { useState, useMemo, useEffect } from 'react';
import './AvatarGeneratorPage.css';
import {
  UI_GROUPS,
  DEFAULT_OPTS,
  generateRandomAvatarOptions,
  createAvatarSvg
} from './avatarUtils';

function AvatarEditor({ onSvgChange, actionButtons }) {
  const [opts, setOpts] = useState(DEFAULT_OPTS);
  const [activeTab, setActiveTab] = useState('Base');

  const handleChange = (key, value) => {
    setOpts(prev => ({ ...prev, [key]: value }));
  };

  const handleRandomize = () => {
    const randomOpts = generateRandomAvatarOptions();
    // Preserve the user's current avatarStyle choice
    randomOpts.avatarStyle = opts.avatarStyle;
    setOpts(randomOpts);
  };

  const avatarSvg = useMemo(() => {
    return createAvatarSvg(opts);
  }, [opts]);

  // Notify parent of SVG change
  useEffect(() => {
      if (onSvgChange) {
          onSvgChange(avatarSvg, opts);
      }
  }, [avatarSvg, opts, onSvgChange]);


  return (
    <div className="avatar-generator-container">
      {/* Left Panel: Preview */}
      <div className="avatar-preview-panel">
        <div 
          className="avatar-display"
          style={{
             borderRadius: opts.avatarStyle === 'Circle' ? '50%' : '16px',
             backgroundColor: opts.avatarStyle === 'Circle' ? '#f1f5f9' : 'transparent',
             overflow: 'hidden',
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: avatarSvg }} style={{ width: '100%', height: '100%' }} />
        </div>
        
        <div className="action-buttons">
            <button className="btn btn-random" onClick={handleRandomize}>
              <span>🎲</span> Randomize Avatar
            </button>
            {/* Action buttons injected by parent */}
            {actionButtons}
        </div>
      </div>

      {/* Right Panel: Controls */}
      <div className="avatar-controls-panel">
         {/* Tabs */}
         <div className="tabs-header">
            {Object.keys(UI_GROUPS).map(group => (
               <button 
                  key={group}
                  className={`tab-btn ${activeTab === group ? 'active' : ''}`}
                  onClick={() => setActiveTab(group)}
               >
                 {group}
               </button>
            ))}
         </div>

         {/* Controls Content */}
         <div className="controls-content">
            <div className="control-section">
               {UI_GROUPS[activeTab].map(field => (
                  <div key={field.id} className="control-group">
                     <label>{field.label}</label>
                     
                     {field.type === 'select' && (
                        <select 
                           className="control-select"
                           value={opts[field.id]}
                           onChange={(e) => handleChange(field.id, e.target.value)}
                        >
                           {field.options.map(opt => (
                              <option key={opt} value={opt}>{opt}</option>
                           ))}
                        </select>
                     )}

                     {field.type === 'color' && (
                        <div className="color-picker-grid">
                           {Object.keys(field.options).map(colorName => (
                              <div 
                                 key={colorName}
                                 className={`color-swatch ${opts[field.id] === colorName ? 'active' : ''}`}
                                 style={{ backgroundColor: `#${field.options[colorName]}` }}
                                 onClick={() => handleChange(field.id, colorName)}
                                 title={colorName}
                              />
                           ))}
                        </div>
                     )}
                  </div>
               ))}
            </div>
         </div>
      </div>
    </div>
  );
}

export default AvatarEditor;
